/* eslint-disable max-len */
import {
  action,
  observable,
} from 'mobx';
import {
  BackendEntity,
  ListBackendEntity,
  ModelOf,
} from 'utils';
import {
  Settings,
} from 'settings';
import {
  omit,
} from 'lodash';
import {
  BaseBackendStore,
} from '../types';
import {
  admins,
  admin,
  download,
} from './requests';
import {
  AdminsDTO,
} from './types';
import {
  BackendStores,
} from '..';
import type {
  SearchObj,
} from '../DoctorsStore/types';

export class AdminsStore extends BaseBackendStore {
  @observable private _entityList: AdminsDTO[] = [];

  filter: SearchObj = {};

  @action public getAll = async (options: any): Promise<AdminsDTO[]> => {
    const query: SearchObj = { };
    if (options.search) {
      query.search = {
        value: options.search,
      };
    }
    if (options.orderBy) {
      query.sort = {
        by: options.orderBy.field,
        type: options.orderDirection.toUpperCase(),
      };
    }
    this.filter = query;
    const response = await this.connections.backend
      .httpGet(`${admins}?take=${options.pageSize}&page=${options.page + 1}&query=${JSON.stringify(query)}`);
    return response;
  };

  @observable entityList = new ListBackendEntity(
    this,
    '_entityList',
    this.getAll,
  );

  constructor(
    public parent: BackendStores,
  ) {
    super();
    this.makeObservable();
    this.registerObservableDrivers();
  }

  @observable private _selectedEntity: AdminsDTO;

  @observable selectedEntity = new BackendEntity(
    this,
    '_selectedEntity',
    this.getOne,
  );

  @action
  public async create(data: AdminsDTO): Promise<void> {
    try {
      await this.connections.backend.httpPost(admins, omit(data, 'confirmPassword'));
      return Promise.resolve();
    } catch (error: any) {
      return Promise.reject(error.response.data.message);
    }
  }

  @action
  public async getOne(id: string): Promise<ModelOf<AdminsDTO>> {
    const response = await this.connections.backend.httpGet(admin(parseInt(id, 10)));
    this.selectedEntity = response;
    return Promise.resolve(response);
  }

  @action updateAdmin = async (id: number, data: Partial<AdminsDTO>) => {
    try {
      const response = await this.connections.backend.httpPut(admin(id), data);
      return Promise.resolve(response);
    } catch (error: any) {
      return Promise.reject(error.response.data.message);
    }
  };

  @action
  public async delete(id: number): Promise<void> {
    const response = await this.connections.backend
      .httpDelete(admin(id));
    return Promise.resolve(response);
  }

  public download() {
    return `${Settings.config.REACT_APP_BASE_URL + download}?query=${JSON.stringify(this.filter)}&lang=${this.parent.parent.ui.localization.currentLanguage.key}`;
  }
}
